import graphql__7560539507525582ef8d from "./__generated__/SendConfirmationInstructionsMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import mapValues from "lodash/mapValues";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__7560539507525582ef8d;

function sendConfirmationInstructions(form, onCompleted) {
  const variables = mapValues(form.fields, field => field.value);

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { sendConfirmationInstructions };
